/* eslint-disable no-restricted-imports */
import React, { useEffect, useState } from "react";
import {
  Button,
  RadioGroup,
  Radio,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { v4 as uuidv4 } from "uuid";
import {
  getAllZimbraConfig,
  getAllUCConfig,
  saveUCConfig,
  modifyZimbraConfig
} from "../modules/Auth/_redux/adminCrud";

export function OptionPage() {
  const useStyles = makeStyles(theme => ({
    popLabelStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1.2rem",
      width: "180px"
    },
    popInputSmallStyle: {
      display: "inline-block",
      marginLeft: "8px",
      fontSize: "1rem",
      width: "40px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    popInputStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1rem",
      width: "80px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    popInputLongStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1rem",
      width: "300px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    labelStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1.2rem",
      width: "160px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "24px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    selectStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      background: "transparent",
      marginRight: "12px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        background: "transparent"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1.2rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleLastStyle: {
      fontSize: "1rem",
      //   fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    subTitlePopStyle: {
      fontSize: "1rem",
      color: "#555555",
      margin: "4px"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      height: "44px",
      borderLeft: "1px solid #dfe2e8"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      width: "100%",
      height: "44px",
      borderLeft: "1px solid #dfe2e8",
      borderRight: "1px solid #dfe2e8"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);

  const [showMass, setShowMass] = React.useState(false);
  const [showExtension, setShowExtension] = React.useState(false);

  const [selectedExt, setSelectedExt] = React.useState(10);
  const [addExt, setAddExt] = React.useState("");

  const [ucEnableReadReceite, setUcEnableReadReceite] = React.useState("TRUE");
  const [ucEnableMass, setUcEnableMass] = React.useState("TRUE");
  const [ucEnableLimitAttach, setUcEnableLimitAttach] = React.useState("FALSE");
  const [ucEnableBlockEmail, setUcEnableBlockEmail] = React.useState("TRUE");
  const [ucEnableClassification, setUcEnableClassification] = React.useState(
    "TRUE"
  );
  const [ucEnableAutoForward, setUcEnableAutoForward] = React.useState("TRUE");
  const [ucEnableQuota, setUcEnableQuota] = React.useState("TRUE");

  const [ucMassEnableMassMaxSize, setUcMassEnableMassMaxSize] = React.useState(
    "FALSE"
  );
  const [
    ucMassEnableDownloadTerm,
    setUcMassEnableDownloadTerm
  ] = React.useState("TRUE");
  const [
    ucMassEnableDownloadCount,
    setUcMassEnableDownloadCount
  ] = React.useState("TRUE");

  const [ucMassLimitMass, setUcMassLimitMass] = React.useState(10485760);
  const [ucMassMaxMassSize, setUcMassMaxMassSize] = React.useState(0);
  const [ucMassSaveFolder, setUcMassSaveFolder] = React.useState(
    "/opt/zimbra/images/mass"
  );
  const [ucMassDownloadTerm, setUcMassDownloadTerm] = React.useState(30);
  const [ucMassDownloadCount, setUcMassDownloadCount] = React.useState(100);
  const [ucMassDownloadHost, setUcMassDownloadHost] = React.useState(
    "http://mail.brainary.io:8109"
  );

  const [extensions, setExtensions] = useState([
    "php"
  ]);

  const handleChangeReadReceit = event => {
    setUcEnableReadReceite(event.target.value);
  };

  const handleChangeEnableMassMaxSize = event => {
    setUcMassEnableMassMaxSize(event.target.value);
  };
  const handleChangeEnableDownloadTerm = event => {
    setUcMassEnableDownloadTerm(event.target.value);
  };
  const handleChangeEnableDownloadCount = event => {
    setUcMassEnableDownloadCount(event.target.value);
  };

  const handleChangeMass = event => {
    setUcEnableMass(event.target.value);
  };
  const handleChangeLimitAttach = event => {
    setUcEnableLimitAttach(event.target.value);
  };

  const handleChangeEmailBlock = event => {
    setUcEnableBlockEmail(event.target.value);
  };
  const handleChangeClassification = event => {
    setUcEnableClassification(event.target.value);
  };
  const handleChangeAutoForward = event => {
    setUcEnableAutoForward(event.target.value);
  };
  const handleChangeEnableQuota = event => {
    setUcEnableQuota(event.target.value);
  };

  const initConfig = () => {
    getAllUCConfig().then(result => {
      console.log("getAllUCConfig", result.data.ucConfig);
      const config = result.data.ucConfig;

      setUcEnableReadReceite(config.ucEnableReadReceite);
      setUcEnableMass(config.ucEnableMass);
      setUcEnableLimitAttach(config.ucEnableLimitAttach);
      setUcEnableBlockEmail(config.ucEnableBlockEmail);
      setUcEnableClassification(config.ucEnableClassification);
      setUcEnableAutoForward(config.ucEnableAutoForward);
      setUcEnableQuota(config.ucEnableQuota);
      setUcMassEnableMassMaxSize(config.ucMassEnableMassMaxSize);
      setUcMassEnableDownloadTerm(config.ucMassEnableDownloadTerm);
      setUcMassEnableDownloadCount(config.ucMassEnableDownloadCount);
      setUcMassLimitMass(config.ucMassLimitMass);
      setUcMassMaxMassSize(config.ucMassMaxMassSize);
      setUcMassSaveFolder(config.ucMassSaveFolder);
      setUcMassDownloadTerm(config.ucMassDownloadTerm);
      setUcMassDownloadCount(config.ucMassDownloadCount);
      setUcMassDownloadHost(config.ucMassDownloadHost);
    })
    .catch(error => {
      console.log(error)
    })

    getAllZimbraConfig().then(result => {


      console.log('getAllZimbraConfig', result)

      const extensions = result.data.allConfig.filter(a => a.n === 'zimbraMtaCommonBlockedExtension');


      console.log("zimbraMtaCommonBlockedExtension", extensions);
      setExtensions(Object.assign(extensions.map(ext => ext._content)));
    })
    .catch(error => {
      console.log(error)
    })
  };

  const saveMain = () => {
    const params = {
      ucEnableReadReceite,
      ucEnableMass,
      ucEnableLimitAttach,
      ucEnableBlockEmail,
      ucEnableClassification,
      ucEnableAutoForward,
      ucEnableQuota
    };

    saveUCConfig(params).then(result => {
      console.log("saveMain", result);

      
      toast('상세 설정이 저장되었습니다.')
    })
    .catch(error => {
      console.log(error)
    })
  };

  const saveMass = () => {
    const params = {
      ucMassEnableMassMaxSize,
      ucMassEnableDownloadTerm,
      ucMassEnableDownloadCount,
      ucMassLimitMass,
      ucMassMaxMassSize,
      ucMassSaveFolder,
      ucMassDownloadTerm,
      ucMassDownloadCount,
      ucMassDownloadHost
    };

    saveUCConfig(params).then(result => {
      console.log("saveMass", result);
    })
    .catch(error => {
      console.log(error)
    })
  };

  const saveExtension = () => {
    const attrs = [];

    extensions.forEach(ext => {
      attrs.push({
        name: "zimbraMtaCommonBlockedExtension",
        value: ext
      })
    })

    console.log("saveExtension", attrs);
    modifyZimbraConfig(attrs).then(result => {
      console.log("modifyZimbraConfig", result);

      toast('저장되었습니다.')
      setRefresh(!refresh);
    })
    .catch(error => {
      console.log(error)
    })


    setShowExtension(false);
  };

  useEffect(() => {
    initConfig();
  }, []);

  useEffect(() => {
    // initConfig();
  }, [refresh]);

  return (
    <>
      <ToastContainer />
      <div
        style={{
          marginTop: "12px",
          marginLeft: "-12px",
          height: "100%"
        }}
      >
        {/* -------------------- */}

        <div className={Styles.boxContainer}>
          <div className={Styles.boxStyle}>
            <div className={Styles.subTitleStyle}>
              <Button
                className={Styles.buttonStyle}
                onClick={() => {
                  saveMain();
                }}
              >
                저장
              </Button>
            </div>
            <div className={Styles.subTitleStyle}>옵션</div>

            <div className={Styles.subTitleLastStyle}>
              {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
              <div className={Styles.labelStyle}>수신확인/발송취소</div>
              <RadioGroup
                label="사용함"
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={ucEnableReadReceite}
                onChange={handleChangeReadReceit}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            <div className={Styles.subTitleLastStyle}>
              <div className={Styles.labelStyle}>대용량메일 사용</div>
              <RadioGroup
                aria-label="방향"
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                value={ucEnableMass}
                onChange={handleChangeMass}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <Button
                  style={{ width: "80px", marginRight: "24px" }}
                  className={Styles.buttonSmallStyle}
                  onClick={() => setShowMass(true)}
                >
                  상세설정
                </Button>
                <FormControlLabel
                  value="FALSE"
                  style={{ marginTop: "4px", fontSize: "1.2rem" }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            <div className={Styles.subTitleLastStyle}>
              <div className={Styles.labelStyle}>첨부제한 사용</div>
              <RadioGroup
                aria-label="방향"
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                value={ucEnableLimitAttach}
                onChange={handleChangeLimitAttach}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <Button
                  style={{ width: "80px", marginRight: "24px" }}
                  className={Styles.buttonSmallStyle}
                  onClick={() => setShowExtension(true)}
                >
                  상세설정
                </Button>
                <FormControlLabel
                  value="FALSE"
                  style={{ marginTop: "4px", fontSize: "1.2rem" }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            {/* <div className={Styles.subTitleLastStyle}>
              <div className={Styles.labelStyle}>개인정보 변경</div>
              <RadioGroup
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={ucEna}
                onChange={handleChangeModifyProfile}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div> */}

            {/* <div className={Styles.subTitleLastStyle}>
              <div className={Styles.labelStyle}>메일 자동삭제</div>
              <RadioGroup
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={ucEna}
                onChange={handleChangeAutoClean}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <Button
                  style={{ width: "80px", marginRight: "24px" }}
                  className={Styles.buttonSmallStyle}
                  onClick={() => setShowAutoClean(true)}
                >
                  상세설정
                </Button>
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div> */}

            <div className={Styles.subTitleLastStyle}>
              <div className={Styles.labelStyle}>수신거부 설정</div>
              <RadioGroup
                aria-label="방향"
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                value={ucEnableBlockEmail}
                onChange={handleChangeEmailBlock}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />

                <FormControlLabel
                  value="FALSE"
                  style={{ marginTop: "4px", fontSize: "1.2rem" }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            <div className={Styles.subTitleLastStyle}>
              {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
              <div className={Styles.labelStyle}>자동분류 설정</div>
              <RadioGroup
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={ucEnableClassification}
                onChange={handleChangeClassification}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            <div className={Styles.subTitleLastStyle}>
              {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
              <div className={Styles.labelStyle}>자동전송 설정</div>
              <RadioGroup
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={ucEnableAutoForward}
                onChange={handleChangeAutoForward}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            <div className={Styles.subTitleLastStyle}>
              {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
              <div className={Styles.labelStyle}>메일쿼터 적용</div>
              <RadioGroup
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={ucEnableQuota}
                onChange={handleChangeEnableQuota}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            <Dialog
              open={showExtension}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">첨부제한 설정</DialogTitle>
              <DialogContent>
                <div className={Styles.subTitlePopStyle}>
                  <input
                    type="text"
                    placeholder="파일 확장자를 입력하세요. ex) asf"
                    value={addExt}
                    className={Styles.popInputLongStyle}
                    style={{ height: "32px", paddingLeft: "8px" }}
                    onChange={e => {
                      setAddExt(e.target.value);
                    }}
                  />
                  <img
                    src={toAbsoluteUrl("/media/images/btn_people_plus.svg")}
                    alt=""
                    style={{ marginLeft: "4px" }}
                    onClick={() => {
                      setExtensions([...[addExt], ...extensions]);
                      setAddExt("");
                      setRefresh(!refresh);
                    }}
                  />
                </div>
                <div className={Styles.subTitlePopStyle}>
                  <div
                    className={Styles.popInputLongStyle}
                    style={{
                      marginTop: "0px",
                      borderRadius: "4px 4px 4px 4px",
                      border: "1px solid lightgray",
                      height: "200px",
                      overflow: "scroll"
                    }}
                  >
                    {extensions.map((ext, index) => (
                      <div
                        style={{
                          height: "32px",
                          lineHeight: "32px",
                          paddingLeft: "8px",
                          background: `${
                            index === selectedExt ? "#f1f3f6" : "unset"
                          }`
                        }}
                        onClick={() => {
                          setSelectedExt(index);
                          setRefresh(!refresh);
                        }}
                      >
                        {ext}
                      </div>
                    ))}
                  </div>
                  <img
                    src={toAbsoluteUrl("/media/images/btn_people_minus.svg")}
                    alt=""
                    style={{
                      marginLeft: "4px",
                      verticalAlign: "top"
                    }}
                    onClick={() => {
                      extensions.splice(selectedExt, 1);
                      setExtensions(extensions);
                      setRefresh(!refresh);
                    }}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    paddingBottom: "8px"
                  }}
                >
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      setAddExt('')
                      setShowExtension(false);
                    }}
                  >
                    취소
                  </Button>
                  <Button
                    style={{ marginLeft: "24px" }}
                    className={[
                      Styles.buttonSmallStyle
                      //   !checkIpAddress() && Styles.buttonDisableStyle
                    ]}
                    autoFocus
                    onClick={() => {
                      saveExtension();
                    }}
                  >
                    저장
                  </Button>
                </div>
              </DialogActions>
            </Dialog>

            <Dialog
              open={showMass}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">대용량메일 설정</DialogTitle>
              <DialogContent>
                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>
                    대용량첨부 전환 크기 <span style={{ color: "red" }}>*</span>
                  </div>
                  <input
                    type="text"
                    value={ucMassLimitMass}
                    className={Styles.popInputStyle}
                    onChange={e => {
                      setUcMassLimitMass(e.target.value);
                    }}
                  />{" "}
                  MB
                </div>

                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>
                    대용량첨부 최대 크기
                  </div>
                  <RadioGroup
                    label="사용함"
                    name="gender1"
                    style={{
                      display: "inline-block",
                      fontSize: "1rem"
                    }}
                    value={ucMassEnableMassMaxSize}
                    onChange={handleChangeEnableMassMaxSize}
                  >
                    <FormControlLabel
                      value="TRUE"
                      style={{
                        marginTop: "4px",
                        marginRight: "12px",
                        fontSize: "1rem"
                      }}
                      control={<Radio />}
                      label=""
                    />
                    <input
                      type="text"
                      value={ucMassMaxMassSize}
                      style={{ width: "80px", marginLeft: "-14px" }}
                      className={Styles.popInputSmallStyle}
                      onChange={e => {
                        setUcMassMaxMassSize(e.target.value);
                      }}
                    />{" "}
                    MB
                    <FormControlLabel
                      value="FALSE"
                      style={{
                        marginTop: "4px",
                        marginLeft: "12px",
                        fontSize: "1rem"
                      }}
                      control={<Radio />}
                      label="일반 첨부 최대 크기와 동일"
                    />
                  </RadioGroup>
                </div>

                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>
                    대용량첨부 저장 디렉토리
                  </div>

                  <input
                    type="text"
                    value={ucMassSaveFolder}
                    className={Styles.popInputLongStyle}
                    onChange={e => {
                      setUcMassSaveFolder(e.target.value);
                    }}
                  />
                </div>

                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>다운로드 기간</div>
                  <RadioGroup
                    label="사용함"
                    name="gender1"
                    style={{
                      display: "inline-block",
                      fontSize: "1.2rem",
                      height: "34px"
                    }}
                    value={ucMassEnableDownloadTerm}
                    onChange={handleChangeEnableDownloadTerm}
                  >
                    <FormControlLabel
                      value="TRUE"
                      style={{
                        marginTop: "4px",
                        marginRight: "12px",
                        fontSize: "1.2rem"
                      }}
                      control={<Radio />}
                      label=""
                    />
                    <input
                      type="text"
                      value={ucMassDownloadTerm}
                      style={{ marginLeft: "-14px" }}
                      className={Styles.popInputSmallStyle}
                      onChange={e => {
                        setUcMassDownloadTerm(e.target.value);
                      }}
                    />{" "}
                    일
                    <FormControlLabel
                      value="FALSE"
                      style={{
                        marginTop: "4px",
                        marginLeft: "12px",
                        fontSize: "1.2rem"
                      }}
                      control={<Radio />}
                      label="무제한"
                    />
                  </RadioGroup>
                </div>

                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>다운로드 제한횟수</div>
                  <RadioGroup
                    label="사용함"
                    name="gender1"
                    style={{
                      display: "inline-block",
                      fontSize: "1.2rem",
                      height: "44px"
                    }}
                    value={ucMassEnableDownloadCount}
                    onChange={handleChangeEnableDownloadCount}
                  >
                    <FormControlLabel
                      value="TRUE"
                      style={{
                        marginTop: "4px",
                        marginRight: "12px",
                        fontSize: "1.2rem"
                      }}
                      control={<Radio />}
                      label=""
                    />
                    <input
                      type="text"
                      value={ucMassDownloadCount}
                      style={{ marginLeft: "-14px" }}
                      className={Styles.popInputSmallStyle}
                      onChange={e => {
                        setUcMassDownloadCount(e.target.value);
                      }}
                    />{" "}
                    회
                    <FormControlLabel
                      value="FALSE"
                      style={{
                        marginTop: "4px",
                        marginLeft: "12px",
                        fontSize: "1.2rem"
                      }}
                      control={<Radio />}
                      label="무제한"
                    />
                  </RadioGroup>
                </div>

                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>다운로드 Host</div>

                  <input
                    type="text"
                    value={ucMassDownloadHost}
                    className={Styles.popInputLongStyle}
                    onChange={e => {
                      setUcMassDownloadHost(e.target.value);
                    }}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    paddingBottom: "8px"
                  }}
                >
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      setShowMass(false);
                    }}
                  >
                    취소
                  </Button>
                  <Button
                    style={{ marginLeft: "24px" }}
                    className={[
                      Styles.buttonSmallStyle
                      //   !checkIpAddress() && Styles.buttonDisableStyle
                    ]}
                    autoFocus
                    onClick={() => {
                      saveMass();
                    }}
                  >
                    저장
                  </Button>
                </div>
              </DialogActions>
            </Dialog>

            {/* <Dialog
              open={showAutoClean}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                메일 자동삭제 설정
              </DialogTitle>
              <DialogContent>
                <div className={Styles.subTitleStyle}>메일함별 삭제 설정</div>
                ‘강제적용’에 체크한 경우, 사용자가 자동삭제 설정을 변경할 수
                없습니다.
                <div>
                  <div className={Styles.headerRowStyle}>
                    <div
                      className={Styles.headerColStyle}
                      style={{ width: "200px" }}
                    >
                      메일함
                    </div>
                    <div
                      className={Styles.headerColStyle}
                      style={{ width: "100px" }}
                    >
                      강제적용
                    </div>
                    <div
                      className={Styles.headerCol100Style}
                      style={{ width: "384px" }}
                    >
                      메일함 자동 삭제 설정
                    </div>
                  </div>

                  
                  <div
                    className={Styles.dataRowStyle}
                    style={{ height: "72px" }}
                  >
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "200px", height: "72px" }}
                    >
                      받은메일함
                    </div>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "100px", height: "72px" }}
                    >
                      <Checkbox
                        // checked={autoLogin}
                        onChange={e => {
                          //   setAutoLogin(!autoLogin);
                        }}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    </div>
                    <div
                      className={Styles.dataCol100Style}
                      style={{ width: "384px", height: "72px" }}
                    >
                      <div style={{ height: "34px" }}>
                        <input
                          type="text"
                          value={periodInbox}
                          className={Styles.popInputSmallStyle}
                          onChange={e => {
                            setPeriodInbox(e.target.value);
                          }}
                        />{" "}
                        일 지난 메일 삭제
                      </div>
                      <RadioGroup
                        label="사용함"
                        name="gender1"
                        style={{
                          display: "inline-block",
                          fontSize: "1.2rem",
                          marginTop: "-6px",
                          height: "24px"
                        }}
                        value={enableDeleteTarget}
                        onChange={handleChangeDeleteTarget}
                      >
                        <FormControlLabel
                          value="ALL"
                          style={{
                            display: "inline-block",
                            marginTop: "4px",
                            marginLeft: "0px",
                            fontSize: "1.2rem"
                          }}
                          control={<Radio />}
                          label="모든 메일 삭제"
                        />
                        <FormControlLabel
                          value="READ"
                          style={{
                            display: "inline-block",
                            marginTop: "4px",
                            marginLeft: "0px",
                            fontSize: "1.2rem"
                          }}
                          control={<Radio />}
                          label="읽은 메일만 삭제"
                        />
                      </RadioGroup>
                    </div>
                  </div>

                  
                  <div className={Styles.dataRowStyle}>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "200px" }}
                    >
                      보낸메일함
                    </div>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "100px" }}
                    >
                      <Checkbox
                        // checked={autoLogin}
                        onChange={e => {
                          //   setAutoLogin(!autoLogin);
                        }}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    </div>
                    <div
                      className={Styles.dataCol100Style}
                      style={{ width: "384px" }}
                    >
                      <input
                        type="text"
                        value={periodInbox}
                        className={Styles.popInputSmallStyle}
                        onChange={e => {
                          setPeriodInbox(e.target.value);
                        }}
                      />{" "}
                      일 지난 메일 삭제
                    </div>
                  </div>

                  
                  <div className={Styles.dataRowStyle}>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "200px" }}
                    >
                      내게쓴메일함
                    </div>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "100px" }}
                    >
                      <Checkbox
                        // checked={autoLogin}
                        onChange={e => {
                          //   setAutoLogin(!autoLogin);
                        }}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    </div>
                    <div
                      className={Styles.dataCol100Style}
                      style={{ width: "384px" }}
                    >
                      <input
                        type="text"
                        value={periodInbox}
                        className={Styles.popInputSmallStyle}
                        onChange={e => {
                          setPeriodInbox(e.target.value);
                        }}
                      />{" "}
                      일 지난 메일 삭제
                    </div>
                  </div>

                  
                  <div className={Styles.dataRowStyle}>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "200px" }}
                    >
                      임시메일함
                    </div>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "100px" }}
                    >
                      <Checkbox
                        // checked={autoLogin}
                        onChange={e => {
                          //   setAutoLogin(!autoLogin);
                        }}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    </div>
                    <div
                      className={Styles.dataCol100Style}
                      style={{ width: "384px" }}
                    >
                      <input
                        type="text"
                        value={periodInbox}
                        className={Styles.popInputSmallStyle}
                        onChange={e => {
                          setPeriodInbox(e.target.value);
                        }}
                      />{" "}
                      일 지난 메일 삭제
                    </div>
                  </div>

                  
                  <div className={Styles.dataRowStyle}>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "200px" }}
                    >
                      예약메일함
                    </div>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "100px" }}
                    >
                      <Checkbox
                        // checked={autoLogin}
                        onChange={e => {
                          //   setAutoLogin(!autoLogin);
                        }}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    </div>
                    <div
                      className={Styles.dataCol100Style}
                      style={{ width: "384px" }}
                    >
                      <input
                        type="text"
                        value={periodInbox}
                        className={Styles.popInputSmallStyle}
                        onChange={e => {
                          setPeriodInbox(e.target.value);
                        }}
                      />{" "}
                      일 지난 메일 삭제
                    </div>
                  </div>

                  
                  <div className={Styles.dataRowStyle}>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "200px" }}
                    >
                      휴지통
                    </div>
                    <div
                      className={Styles.dataColStyle}
                      style={{ width: "100px" }}
                    >
                      <Checkbox
                        // checked={autoLogin}
                        onChange={e => {
                          //   setAutoLogin(!autoLogin);
                        }}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    </div>
                    <div
                      className={Styles.dataCol100Style}
                      style={{ width: "384px" }}
                    >
                      <input
                        type="text"
                        value={periodInbox}
                        className={Styles.popInputSmallStyle}
                        onChange={e => {
                          setPeriodInbox(e.target.value);
                        }}
                      />{" "}
                      일 지난 메일 삭제
                    </div>
                  </div>
                </div>
                <div className={Styles.subTitleStyle}>삭제 설정</div>
                자동삭제 및 사용자가 삭제한 메일을 일정 기간동안 저장 디렉토리에
                백업합니다.
                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>삭제 메일 저장*</div>
                  <RadioGroup
                    label="사용함"
                    name="gender1"
                    style={{
                      display: "inline-block",
                      fontSize: "1.2rem",
                      height: "44px"
                    }}
                    value={enableReadReceit}
                    onChange={handleChangeReadReceit}
                  >
                    <FormControlLabel
                      value="TRUE"
                      style={{
                        marginTop: "4px",
                        marginRight: "12px",
                        fontSize: "1.2rem"
                      }}
                      control={<Radio />}
                      label="예"
                    />

                    <FormControlLabel
                      value="FALSE"
                      style={{
                        marginTop: "4px",
                        marginLeft: "12px",
                        fontSize: "1.2rem"
                      }}
                      control={<Radio />}
                      label="아니요"
                    />
                  </RadioGroup>
                </div>
                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>
                    삭제 메일 저장 디렉토리
                  </div>

                  <input
                    type="text"
                    value={massHost}
                    className={Styles.popInputLongStyle}
                    onChange={e => {
                      setMassHost(e.target.value);
                    }}
                  />
                </div>
                <div className={Styles.subTitlePopStyle}>
                  <div className={Styles.popLabelStyle}>삭제기간</div>
                  <input
                    type="text"
                    value={periodInbox}
                    style={{ marginLeft: "0px" }}
                    className={Styles.popInputSmallStyle}
                    onChange={e => {
                      setPeriodInbox(e.target.value);
                    }}
                  />{" "}
                  일 후 자동 삭제
                </div>
              </DialogContent>
              <DialogActions>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    paddingBottom: "8px"
                  }}
                >
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      setShowAutoClean(false);
                    }}
                  >
                    취소
                  </Button>
                  <Button
                    style={{ marginLeft: "24px" }}
                    className={[
                      Styles.buttonSmallStyle
                      //   !checkIpAddress() && Styles.buttonDisableStyle
                    ]}
                    autoFocus
                    onClick={() => {
                      setShowAutoClean(false);
                    }}
                  >
                    저장
                  </Button>
                </div>
              </DialogActions>
            </Dialog> */}
          </div>
        </div>
      </div>
    </>
  );
}
